import { useState, Fragment } from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { ChevronDown, ChevronRight } from "lucide-react";
import { money } from "@/components/reports/reportUtils";

export function ReporteCxP({ data }) {
  const items = data?.items || [];
  const [expanded, setExpanded] = useState({});
  return (
    <div>
      <p className="mb-3 text-sm text-muted-foreground" data-testid="reporte-cxp-total">
        Total pendiente: <span className="font-semibold text-foreground">{money(data?.total_pendiente_usd)} USD</span>
        {data?.truncado && <span className="ml-2 text-amber-600">— resultado truncado, exportá a Excel para verlo completo</span>}
      </p>
      <Table data-testid="reporte-cxp-table">
        <TableHeader>
          <TableRow>
            <TableHead /><TableHead>Carrier</TableHead><TableHead className="text-right">Costos pendientes</TableHead>
            <TableHead className="text-right">Monto USD</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {items.map((r) => (
            <Fragment key={r.carrier_id}>
              <TableRow className="cursor-pointer" onClick={() => setExpanded((e) => ({ ...e, [r.carrier_id]: !e[r.carrier_id] }))}
                        data-testid={`reporte-cxp-row-${r.carrier_id}`}>
                <TableCell>{expanded[r.carrier_id] ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}</TableCell>
                <TableCell>{r.carrier_nombre}</TableCell>
                <TableCell className="text-right">{r.cantidad}</TableCell>
                <TableCell className="text-right font-medium">{money(r.monto_total_usd)}</TableCell>
              </TableRow>
              {expanded[r.carrier_id] && (
                <TableRow>
                  <TableCell />
                  <TableCell colSpan={3} className="bg-slate-50 p-0">
                    <div className="space-y-1 p-3 text-xs" data-testid={`reporte-cxp-detalle-${r.carrier_id}`}>
                      {r.detalle.map((d, i) => (
                        <div key={i} className="flex justify-between">
                          <span className="font-mono">{d.numero_load} — {d.tipo_costo}</span>
                          <span>{money(d.monto_usd)} · {d.antiguedad}</span>
                        </div>
                      ))}
                    </div>
                  </TableCell>
                </TableRow>
              )}
            </Fragment>
          ))}
          {items.length === 0 && (
            <TableRow><TableCell colSpan={4} className="text-center text-sm text-muted-foreground py-8">Sin resultados para los filtros aplicados.</TableCell></TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
}
